import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import HelpSupportGridItem from './components/gridItem'
import { GeneralSetting } from '@apis/index'
import { useEffect } from 'react'

const AdminHelpSupport = () => {
  const navigate = useNavigate()
  const { data: supportAgent } = useSelector((state: any) => state.supportAgent)
  const { data: officeDetail } = useSelector((state: any) => state.officeDetail)
  const fetch = async (state: string) => {
    await GeneralSetting.getByKey(state, state).catch(() => {})
  }

  const onClick = (type: 'supportAgent' | 'officialDetail') => {
    switch (type) {
      case 'supportAgent':
        if (!!supportAgent?.id) {
          navigate(
            `/admin/help-support/update/support-agent/${supportAgent?.id}`,
            { state: supportAgent },
          )
        } else {
          navigate(`/admin/help-support/create/support-agent`)
        }
        break
      case 'officialDetail':
        if (!!officeDetail?.id) {
          navigate(
            `/admin/help-support/update/office-detail/${officeDetail?.id}`,
            { state: officeDetail },
          )
        } else {
          navigate(`/admin/help-support/create/office-detail`)
        }
        break
      default:
        console.log('Unknown type')
    }
  }

  useEffect(() => {
    if (!officeDetail?.id) {
      fetch('officeDetail')
    }
    if (!supportAgent?.id) {
      fetch('supportAgent')
    }
  }, [])

  return (
    <HelpSupportGridItem
      items={[
        {
          title: 'Support Agent',
          Icon: 'userFill',
          onClickEdit: () => onClick('supportAgent'),
        },
        {
          title: 'Office Details',
          Icon: 'userFill',
          onClickEdit: () => onClick('officialDetail'),
        },
      ]}
    />
  )
}

export default AdminHelpSupport
